import { Skeleton, Flex, Box, Paper, Grid, createStyles } from "@mantine/core"
import React from "react"

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  paper: {
    padding: theme.spacing.xl,
    boxShadow: theme.shadows.light,

    [theme.fn.smallerThan("lg")]: {
      padding: theme.spacing.md,
    },

    [theme.fn.smallerThan("md")]: {
      padding: theme.spacing.xs,
    },

    [theme.fn.smallerThan("xs")]: {
      padding: 0,
    },
  },

  gridElem: {
    padding: theme.spacing.xl,

    [theme.fn.smallerThan("lg")]: {
      padding: theme.spacing.md,
    },

    [theme.fn.smallerThan("md")]: {
      padding: theme.spacing.xs,
    },

    [theme.fn.smallerThan("xs")]: {
      "&:first-of-type": {
        padding: theme.spacing.xl,
      },

      "&:last-of-type": {
        padding: 0,
      },
    },
  },

  title: {
    [theme.fn.smallerThan("md")]: {
      fontSize: theme.headings.sizes.h2.fontSize,
    },

    [theme.fn.smallerThan("xs")]: {
      fontSize: theme.headings.sizes.h3.fontSize,
    },
  },

  image: {
    borderRadius: theme.radius.xl,

    [theme.fn.smallerThan("xs")]: {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
  },
}))

// ----------------------------------------------------------------------

export function ArticleListElementSkeleton(): React.JSX.Element {
  const { classes } = useStyles()

  return (
    <Paper shadow="sm" radius="xl" className={classes.paper}>
      <Grid grow gutter={0}>
        <Grid.Col span={12} xs={8} className={classes.gridElem} order={2} orderXs={1}>
          <Flex direction="column">
            <Skeleton height={18} width="100%"/>
            <Skeleton height={18} mt="md" width="70%"/>
            <Skeleton height={36} mt="xl" width={160} radius="xl"/>
            <Box mt="xl">
              {new Array(10).fill(null).map((_, index) => (
                <Skeleton key={index} height={12} mt="xs" width={`${Math.floor(Math.random() * (100 - 35) + 35)}%`}/>
              ))}
            </Box>
            <Skeleton height={36} mt="xl" width={100} radius="xl"/>
          </Flex>
        </Grid.Col>
        <Grid.Col span={12} xs={4} className={classes.gridElem} order={1} orderXs={2}>
          <Skeleton height={435} width="100%" className={classes.image}/>
        </Grid.Col>
      </Grid>
    </Paper>
  )
}
